// Original client photographs; addresses and construction dates are not inferred.
export const SITE_PHOTOS = [
  { id: 'A012', url: '/assets/site-photos/a012.webp', caption: 'Máy khoan và lồng thép tại mặt bằng thi công' },
  { id: 'A015', url: '/assets/site-photos/a015.webp', caption: 'Mũi khoan xoắn — tư liệu thi công' },
  { id: 'A017', url: '/assets/site-photos/a017.webp', caption: 'Gia công và tập kết lồng thép' },
  { id: 'A022', url: '/assets/site-photos/a022.webp', caption: 'Thiết bị tại công trường' },
  { id: 'A023', url: '/assets/site-photos/a023.webp', caption: 'Lồng thép chuẩn bị thi công' },
  { id: 'A039', url: '/assets/site-photos/a039.webp', caption: 'Thiết bị tại mặt bằng trong nhà' },
  { id: 'A049', url: '/assets/site-photos/a049.webp', caption: 'Mặt bằng và kết cấu thép tại công trường' },
  { id: 'A060', url: '/assets/site-photos/a060.webp', caption: 'Toàn cảnh mặt bằng thi công' },
];

export function servicePhoto(id: string, index: number, currentImage?: string) {
  if (/^khoan-coc-nhoi-tai-(hoan-kiem|dong-da|ba-dinh|hai-ba-trung|hoang-mai|thanh-xuan|long-bien|nam-tu-liem|bac-tu-liem|tay-ho|cau-giay|ha-dong)$/.test(id)) return `/assets/banners/district-${id.replace('khoan-coc-nhoi-tai-', '')}-20261008.webp`;
  // Keep future admin uploads; replace only the old bundled/reference images.
  if (currentImage && !currentImage.includes('/assets/optimized/') && !currentImage.includes('raw.githubusercontent.com/dinhkhanhtung/khoancocnhoi-website')) return currentImage;
  if (id === 'khoan-coc-nhoi-kho') return SITE_PHOTOS[1].url;
  if (id.includes('cong-nghiep') || id.includes('d800')) return SITE_PHOTOS[7].url;
  if (id.includes('mini')) return SITE_PHOTOS[5].url;
  if (id.includes('dan')) return SITE_PHOTOS[0].url;
  if (id.includes('lun') || id.includes('gia-co')) return SITE_PHOTOS[5].url;
  return SITE_PHOTOS[Array.from(id).reduce((sum, char) => sum + char.charCodeAt(0), 0) % SITE_PHOTOS.length].url;
}
